import React from 'react';
import { Grid, Typography, Box, Paper } from '@mui/material';
import TextInput from '../../../../sharedModules/form/components/TextInput';
import InspectionRadioGroup from '../InspectionRadioGroup';
import { conditionOptions, conditionWithNaOptions } from '../../config/options';
import MediaUploadSection from '../../../../sharedModules/mediaUpload/MediaUploadSection';
import type { InspectionFormValues } from '../../utils/inspectionReportFormDefaults';
import { sectionHeaderSx } from './inspectionReportFormStyles';

interface IndoorAirQualitySectionProps {
  formValues: InspectionFormValues;
  updateField: (field: string, value: unknown) => void;
  airQualityPhotos: File[];
  onAirQualityPhotosChange: (files: File[]) => void;
}

const IndoorAirQualitySection: React.FC<IndoorAirQualitySectionProps> = ({
  formValues,
  updateField,
  airQualityPhotos,
  onAirQualityPhotosChange,
}) => (
  <Paper variant="outlined" sx={{ mb: 3, overflow: 'hidden' }}>
    <Typography sx={sectionHeaderSx}>Indoor Air Quality</Typography>
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InspectionRadioGroup
            label="Air Filter Condition"
            radioOptions={conditionOptions}
            value={formValues.airQualityAirFilterCondition}
            setValue={(val) => updateField('airQualityAirFilterCondition', val)}
          />
        </Grid>
        <Grid item xs={12}>
          <InspectionRadioGroup
            label="iWave"
            radioOptions={conditionWithNaOptions}
            value={formValues.airQualityIwave}
            setValue={(val) => updateField('airQualityIwave', val)}
          />
        </Grid>
        <Grid item xs={12}>
          <InspectionRadioGroup
            label="Humidifier"
            radioOptions={conditionWithNaOptions}
            value={formValues.airQualityHumidifier}
            setValue={(val) => updateField('airQualityHumidifier', val)}
          />
        </Grid>
        <Grid item xs={12}>
          <InspectionRadioGroup
            label="Dehumidifier"
            radioOptions={conditionWithNaOptions}
            value={formValues.airQualityDehumidifier}
            setValue={(val) => updateField('airQualityDehumidifier', val)}
          />
        </Grid>
        <Grid item xs={12}>
          <InspectionRadioGroup
            label="Programmable Thermostat"
            radioOptions={conditionWithNaOptions}
            value={formValues.airQualityProgrammableThermostat}
            setValue={(val) => updateField('airQualityProgrammableThermostat', val)}
          />
        </Grid>
      </Grid>
      <TextInput
        label="Air Quality Notes"
        value={formValues.airQualityNotes}
        valueChanged={(val) => updateField('airQualityNotes', val)}
        multiline
        rows={3}
      />
      <MediaUploadSection label="Air Quality Photos" files={airQualityPhotos} onChange={onAirQualityPhotosChange} />
    </Box>
  </Paper>
);

export default IndoorAirQualitySection;
